import { render, staticRenderFns } from "./il-wizard.vue?vue&type=template&id=faead070"
import script from "./il-wizard.vue?vue&type=script&lang=ts"
export * from "./il-wizard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports